import { AfterViewInit, Component, ViewChild } from "@angular/core";
import { DxChartComponent, DxPivotGridComponent } from "devextreme-angular";
import { DxiSeriesComponent } from "devextreme-angular/ui/nested";
import { exportWidgets } from 'devextreme/viz/export';
import { exportPivotGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';

@Component({
    selector: 'O2PortalAwardsByProcess',
    templateUrl: './o2-portal-awards-by-process.component.html',
    styleUrls: ['./o2-portal-awards-by-process.component.scss']
})

export class O2PortalAwardsByProcessComponent implements AfterViewInit {

    isLoadPanelVisible: boolean = false;
    o2PortalAwardsByProcessData: any;
    o2PortalAwardsByProcessBarChartData: any;
    o2PortalAwardsByProcessPieChartData: any;
    pivotGridProcessRegionDataSource: any;
    pivotGridCompetitorRegionDataSource: any;
    resolveOverlappingTypes = ['shift', 'hide', 'none'];
    colors: Map<string, string>;

    @ViewChild(DxChartComponent, { static: false }) dxChart: DxChartComponent;
    @ViewChild(DxiSeriesComponent, { static: false }) dxPieChart: DxChartComponent;
    @ViewChild('VolumeAnalysisByCompetitorAndRegion', { static: false }) competitorAndRegionGrid: DxPivotGridComponent;
    @ViewChild('VolumeAnalysisByProcessAndRegion', { static: false }) processAndRegionGrid: DxPivotGridComponent;

    constructor() {
        this.customizeLabel = this.customizeLabel.bind(this);
        this.colors = new Map<string, string>();
    }

    ngAfterViewInit() {
        this.dxChart.instance.render();
    }

    export() {
        const chartInstance = this.dxChart.instance;
        const pieChartInstance = this.dxPieChart.instance;

        exportWidgets([[pieChartInstance, chartInstance]], {
            fileName: 'ASUAwardsByProcess',
            format: 'PNG',
        });
    }

    exportExcel(e) {
        const context = this;
        const workbook = new Workbook();
        const regwb = workbook.addWorksheet('Competitor And Region');
        const appwb = workbook.addWorksheet('Application And Region');

        exportPivotGrid({
            worksheet: regwb,
            component: context.competitorAndRegionGrid.instance,

        }).then(() => {
            exportPivotGrid({
                worksheet: appwb,
                component: context.processAndRegionGrid.instance,
            }).then(() => {
                workbook.xlsx.writeBuffer().then((buffer) => {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'ASU_Awards_By_Process.xlsx');
                });
            });
        })

    }

    getO2PortalAwardsByRegion(o2PortalAwardsData) {
        this.o2PortalAwardsByProcessData = o2PortalAwardsData;
        this.isLoadPanelVisible = false;
        this.colors.clear();
        this.setDataSources();
    }

    setDataSources() {

        this.pivotGridProcessRegionDataSource = {
            fields: [{
                caption: 'LASURegions',
                width: 120,
                dataField: 'lasuregions',
                area: 'row',
            }, {
                dataField: 'process',
                area: 'column',
            }, {
                groupName: 'process',
                visible: false,
            }, {
                caption: 'Total',
                dataField: 'totalOxygen',
                dataType: 'number',
                summaryType: 'sum',
                area: 'data',
                format: {
                    precision: Number
                }
            }],
            store: this.o2PortalAwardsByProcessData,
        };

        this.pivotGridCompetitorRegionDataSource = {
            fields: [{
                caption: 'topCompetitors',
                width: 120,
                dataField: 'topCompetitors',
                area: 'row',
            }, {
                dataField: 'process',
                area: 'column',
            }, {
                groupName: 'process',
                visible: false,
            }, {
                caption: 'Total',
                dataField: 'totalOxygen',
                dataType: 'number',
                summaryType: 'sum',
                area: 'data',
                format: {
                    precision: Number
                }
            }],
            store: this.o2PortalAwardsByProcessData,
        };

        this.o2PortalAwardsByProcessData.sort((a, b) => a.awardYear - b.awardYear);

        this.o2PortalAwardsByProcessBarChartData = [... this.o2PortalAwardsByProcessData].map(item => ({ ...item }));
        this.o2PortalAwardsByProcessBarChartData = this.o2PortalAwardsByProcessBarChartData.reduce((accm, item) => {

            let accItem = accm.find(ai => ai.awardYear === item.awardYear && ai.process === item.process)

            if (accItem) {
                accItem.totalOxygen = Math.round(accItem.totalOxygen + item.totalOxygen)
                // To remove comma from long datatype field = converted to string
                accItem.awardYear = accItem.awardYear.toString()
            } else {
                item.awardYear = item.awardYear.toString()
                accm.push(item)
            }

            return accm;
        }, []);


        this.o2PortalAwardsByProcessData.sort((a, b) => a.process - b.process);
        let allRegionsArrayData = [... this.o2PortalAwardsByProcessData].map(item => ({ ...item }));
        allRegionsArrayData = allRegionsArrayData.reduce((acc, item) => {

            let accItem = acc.find(ai => ai.process === item.process)

            if (accItem) {
                accItem.totalOxygen = Math.round(accItem.totalOxygen + item.totalOxygen)
            } else {
                acc.push(item)
            }

            return acc;
        }, []);

        let totalCountArray = [...allRegionsArrayData].map(item => ({ ...item }));
        const total = totalCountArray.reduce((prevValue, item) => Math.round(prevValue + item.totalOxygen), 0);

        this.o2PortalAwardsByProcessPieChartData = allRegionsArrayData.map((item, index) => {
            let cumulativeCount = item.totalOxygen;
            return {
                process: item.process,
                cumulativePercent: Math.round(cumulativeCount * 100 / total),
            };
        });
    }

    customizeLabel(arg) {
        if (!this.colors.has(arg.argumentText)) {
            this.colors.set(arg.argumentText, arg.point.getColor());
        }

        return `${arg.argumentText} (${arg.percentText})`;
    }

    customizeTooltip(arg: any) {
        return {
            text: `${arg.seriesName} : ${arg.valueText}` + ' mtpd',
        };
    }

    onCellPrepared(e) {
        if (e.area === "data" && e.cell.text === "") {
            e.cellElement.textContent = "0";
        }
    }

    customizePoint = (arg: any) => {
        if (this.colors.has(arg.data.process)) {
            return { color: this.colors.get(arg.data.process), hoverStyle: { color: this.colors.get(arg.data.process) } };
        }
    }
}